import { DocumentStatus, RequiredFile } from '@nemuru-eng/js-api-client';

import { DocumentDetailsAction } from '@/components/modules/Documentation/components/DocumentationDetails/types/documentDetailsActions';
import { DocumentDetailsStandardAction } from '@/components/modules/Documentation/components/DocumentationHeader/types/DocumentDetailsStandardAction';
import { documentationEditModeMapper } from '@/components/modules/Documentation/maps/documentationEditModeMapper';
import { DocumentationCapability } from '@/components/modules/Documentation/types/DocumentationCapability';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { Text } from '@/components/shared/components/Text';

export const useDocumentationRequiredFilesActions = ({
  onClickAction,
  onDownloadFile,
  requiredFile,
}: {
  onClickAction: (action: DocumentDetailsStandardAction | DocumentDetailsAction) => void;
  onDownloadFile: () => Promise<void>;
  requiredFile: RequiredFile;
}) => {
  const UploadFile = {
    display: <Text tId={'UPLOAD_FILE'} />,
    iconName: 'file_upload',
    onClick: () => onClickAction(DocumentDetailsStandardAction.UPLOAD_FILE),
  };

  const DownloadFile = {
    display: <Text tId={'DOWNLOAD_FILE'} />,
    iconName: 'file_download',
    onClick: () => onDownloadFile(),
    disabled: requiredFile?.status === DocumentStatus.PENDING,
  };

  const SetDocumentStatus = {
    display: <Text tId={'SET_DOCUMENT_STATUS'} />,
    iconName: 'tune',
    onClick: () => onClickAction(DocumentDetailsAction.SET_DOCUMENT_STATUS),
  };

  const SetDocumentNotSent = {
    display: <Text tId={'SET_DOCUMENT_REQUIRED_IS_NOT_SENT'} />,
    iconName: 'reply',
    onClick: () => onClickAction(DocumentDetailsStandardAction.SET_DOCUMENT_REQUIRED_IS_NOT_SENT),
    disabled: !requiredFile?.isSent,
  };

  const RemoveRequiredFile = {
    display: <Text tId={'REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED'} />,
    iconName: 'block',
    onClick: () => onClickAction(DocumentDetailsStandardAction.REMOVE_REQUIRED_FILE_TYPE_FROM_DOCUMENTATION_REQUIRED),
  };

  const getActionOptionsArray = (editMode: DocumentationMode) => {
    const documentationCapabilities = documentationEditModeMapper(editMode);

    return documentationCapabilities
      .flatMap((capability) => {
        switch (capability) {
          case DocumentationCapability.UPLOAD:
            return UploadFile;
          case DocumentationCapability.DOWNLOAD:
            return DownloadFile;
          case DocumentationCapability.EDIT_REQUIRED_DOCUMENTS:
            return RemoveRequiredFile;
          case DocumentationCapability.EDIT_DOCUMENT_STATUS:
            return [SetDocumentStatus, SetDocumentNotSent];
        }
      })
      .filter((el) => el !== undefined);
  };
  return { getActionOptionsArray };
};
